import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('pages/authentication/ResetPassword')));
const InvitePage = Loadable(lazy(() => import('pages/authentication/InvitePage')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/:organizationName',
  element: <MinimalLayout />,
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'register',
      element: <AuthRegister />
    },
    {
      path: 'forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: 'reset-password/:id/:token',
      element: <AuthResetPassword />,
      render: (props) => {
        const {id, token} = props.match.params;
        return <AuthResetPassword id={id} token={token} />;
      }
    },
    {
      path: 'invite',
      element: <InvitePage />
    }
  ]
};

export default LoginRoutes;
